import React from 'react';
import { Input } from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/CVE';
import { Title } from './styled';

const CVE = ({ width = '410px', listData, onAdd, onRemove, onValidationChange }) => {
  return (
      <div style={ { width } }>
          <Title>CVE</Title>
        <Input
          placeholder="CVE-YYYY-NNNN"
          errorMessage="CVE not valid"
          validator={ /^CVE-\d{4}-\d{4,7}$/ }
          listData={ listData }
          onAdd= { onAdd }
          onRemove={ onRemove }
          canUpdate
          validateOnChange
          onValidationChange={ onValidationChange }
          inputTestId="kb-cve-input"
          chipTestId="kb-cve-chip"
          removeTestId="kb-cve-chip-remove"
        />
      </div>
  );
};

export default CVE;
